import { LazyLoad } from '../../lazy';

const OurSendDialog = LazyLoad(() => import('./SendDialog'));
const OurShareDialog = LazyLoad(() => import('./ShareDialog'));

export { OurSendDialog, OurShareDialog };
